import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import SelectArticle from './select_article';
import Strapi from '../../services/strapi';
import { Button, Card, CardContent, Grid, Tooltip } from '@material-ui/core';
import Fetcher, { URLBuild } from '../../services/fetcher';
import settings from '../../settings';
import Preview from './preview';
import Generate from './generate';

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1
  }
}));

const SelectArticles = () => {
  const classes = useStyles();

  const [coverLoading, setCoverLoading] = useState<boolean>(false);
  const [coverSource, setCoverSource] = useState<any[]>([]);
  const [selectedArticles, setSelectedArticles] = useState<any[]>(new Array(7).fill(null));

  const [videoLoading, setVideoLoading] = useState<boolean>(false);
  const [videoSource, setVideoSource] = useState<any | undefined>(undefined);
  const [selectedVideo, setSelectedVideo] = useState<any | null>(null);

  const [rdvLoading, setRdvLoading] = useState<boolean>(false);
  const [rdvSource, setRdvSource] = useState<any | undefined>(undefined);
  const [selectedRdv, setSelectedRdv] = useState<any | null>(null);

  const [lastLoading, setLastLoading] = useState<boolean>(false);
  const [lastSource, setLastSource] = useState<any | undefined>(undefined);
  const [selectedLast, setSelectedLast] = useState<any | null>(null);

  const [podcastLoading, setPodcastLoading] = useState<boolean>(false);
  const [podcastSource, setPoscastSource] = useState<any | undefined>(undefined);
  const [selectedPodcast, setSelectedPodcast] = useState<any | null>(null);

  const [valid, setValid] = useState<boolean[]>(new Array(11).fill(false));

  const [toggleModal, setToggleModal] = useState<boolean>(false);
  const [previewData, setPreviewData] = useState<string>('');
  const [previewLoading, setPreviewLoading] = useState<boolean>(false);
  const [previewChecked, setPreviewChecked] = useState<boolean>(false);

  const [toggleGenerate, setToggleGenerate] = useState<boolean>(false);
  const [generateData, setGenerateData] = useState<any>(null);

  useEffect(() => {
    setPreviewChecked(false);
    setValid((oldValid: boolean[]) => {
      const newValid = [...oldValid];
      newValid[7] = !!selectedLast;
      newValid[8] = !!selectedRdv;
      newValid[9] = !!selectedVideo;
      newValid[10] = !!selectedPodcast;
      return newValid;
    });
  }, [selectedLast, selectedRdv, selectedVideo, selectedPodcast]);

  useEffect(() => {
    setCoverLoading(true);
    Strapi.get("cover-home").then((r: any) => {
			setCoverSource(r.body);
		}).finally(() => {
      setCoverLoading(false);
    });
  }, [])

  useEffect(() => {
    setVideoLoading(true);
    const params = {
      _limit: 1,
      _sort: 'publish_date:DESC',
      publish_date_lt: new Date().toISOString(),
      publish_date_null: false
    };
    Strapi.get("videos", params).then((r: any) => {
			if (r && r.length === 1) {
        setVideoSource(r[0]);
      }
		}).finally(() => {
      setVideoLoading(false);
    });
  }, []);

  useEffect(() => {
    setRdvLoading(true);
    const params = {
      _limit: 1,
      _sort: 'publish_date:DESC',
      publish_date_lt: new Date().toISOString(),
      publish_date_null: false
    };
    Strapi.get("rdvs", params).then((r: any) => {
			if (r && r.length === 1) {
        setRdvSource(r[0]);
      }
		}).finally(() => {
      setRdvLoading(false);
    });
  }, []);

  useEffect(() => {
    setPodcastLoading(true);
    const params = {
      _limit: 1,
      _sort: 'publish_date:DESC',
      publish_date_lt: new Date().toISOString(),
      publish_date_null: false
    };
    Strapi.get("podcasts", params).then((r: any) => {
			if (r && r.length === 1) {
        setPoscastSource(r[0]);
      }
		}).finally(() => {
      setPodcastLoading(false);
    });
  }, []);

  useEffect(() => {
    setLastLoading(true)
    Fetcher.get(
      URLBuild(settings.analyticsApi + 'best/article/day', {})
    ).then((r: any) => {
      if (r && r.best && r.best.length > 0) {
        setLastSource(r.best[0]);
      }
    }).finally(() => {
      setLastLoading(false);
    });
  }, []);

  const onArticleChange = (value: any, i: number) => {
    setValid((oldValid: boolean[]) => {
      const newValid = [...oldValid];
      newValid[i] = !!value;
      return newValid;
    });
    setSelectedArticles((oldSelected: any[]) => {
      const newSelected = [...oldSelected];
      if (i >= 0 && i < 7) {
        newSelected[i] = value;
      }
      return newSelected;
    });
  };

  const generate = () => {
    const body: any = {};
    selectedArticles.forEach((val: any, i: number) => {
      body[`article${i + 1}`] = {
        "content-type": val.type + 's',
        "slug": val.data.slug
      };
    });
    body['mostSeen'] = {"content-type": selectedLast.type + 's', "slug": selectedLast.data.slug};
    body['rdv'] = {"content-type": 'rdvs', "slug": selectedRdv.data.slug};
    body['video'] = {"content-type": 'videos', "slug": selectedVideo.data.slug};
    body['podcast'] = {"content-type": 'podcasts', "slug": selectedPodcast.data.slug};
    setToggleGenerate(true);
    setGenerateData({...body});
  };

  const preview = () => {
    setToggleModal(true);
    setPreviewLoading(true);
    const body: any = {};
    selectedArticles.forEach((val: any, i: number) => {
      body[`article${i + 1}`] = {
        "content-type": val.type + 's',
        "slug": val.data.slug
      };
    });
    body['mostSeen'] = {"content-type": selectedLast.type + 's', "slug": selectedLast.data.slug};
    body['rdv'] = {"content-type": 'rdvs', "slug": selectedRdv.data.slug};
    body['video'] = {"content-type": 'videos', "slug": selectedVideo.data.slug};
    body['podcast'] = {"content-type": 'podcasts', "slug": selectedPodcast.data.slug};
    Fetcher.post(
      settings.newsletterApi + 'preview',
      JSON.stringify(body)
    ).then((res: any) => {
      setPreviewChecked(true);
      setPreviewData(res.template);
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setPreviewLoading(false);
    });
  };

  const quitModal = () => {
    setToggleModal(false);
    setPreviewLoading(false);
    setPreviewData('');
  };

  const quitGenerate = () => {
    setToggleGenerate(false);
    setPreviewChecked(false);
    setGenerateData(null);
  };

  return (
    <div>
      <Preview toggleModal={toggleModal} data={previewData} loading={previewLoading} onQuitModal={quitModal} />
      {toggleGenerate && <Generate toggleModal={toggleGenerate} onQuitModal={quitGenerate} body={generateData}/>}
			<Grid container spacing={3} className={classes.container}>
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Button
                onClick={preview}
                disabled={!valid.every(val => val)}
                fullWidth
                variant="outlined"
              >Prévisualiser la Newsletter</Button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Tooltip title="Prévisualisez la newsletter avant de programmer l'envoi" aria-label="add" open={!previewChecked}>
                <Button
                  onClick={generate}
                  disabled={!previewChecked}
                  fullWidth
                  variant="outlined"
                >Programmer l'envoi de la newsletter</Button>
              </Tooltip>
            </CardContent>
          </Card>
        </Grid>
        {selectedArticles.map((_, i) =>
          <Grid item xs={12} key={i}>
            <SelectArticle
              label={`ARTICLE ${i + 1}`}
              default={coverSource.length > i ? coverSource[i] : undefined}
              strapiContent="all"
              onChange={(value: any) => onArticleChange(value, i)}
              loading={coverLoading}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <SelectArticle
            label={`ARTICLE LE PLUS LU`}
            default={lastSource}
            strapiContent="all"
            onChange={setSelectedLast}
            loading={lastLoading}
          />
        </Grid>
        <Grid item xs={12}>
          <SelectArticle
            label={`ARTICLE RENDEZ-VOUS`}
            default={rdvSource}
            strapiContent="rdvs"
            onChange={setSelectedRdv}
            loading={rdvLoading}
          />
        </Grid>
        <Grid item xs={12}>
          <SelectArticle
            label={`ARTICLE VIDÉO`}
            default={videoSource}
            strapiContent="videos"
            onChange={setSelectedVideo}
            loading={videoLoading}
          />
        </Grid>
        <Grid item xs={12}>
          <SelectArticle
            label={`PODCAST`}
            default={podcastSource}
            strapiContent="podcasts"
            onChange={setSelectedPodcast}
            loading={podcastLoading}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default SelectArticles;